<template>
    <div class="layout-workframe">
        <header-bar :logined="logined" @menuToggle="menuToggle"></header-bar>
        <router-view></router-view>
        <footer-bar></footer-bar>
        <div class="menu-bar-workframe" v-show="menuIfShow" @mouseenter="menuToggle(true)" @mouseleave="menuToggle(false)">
            <menu-bar></menu-bar>
        </div>
    </div>
</template>
<script>
    import footerBar from './FooterBar.vue'
    import headerBar from './HeaderBar.vue'
    import menuBar from './MenuBar.vue'

    export default {
        name: "workFrame",
        components: {
            footerBar,
            headerBar,
            menuBar
        },
        data() {
            return {
                imgUrl: process.env.BASE_URL + "img/login_bg.jpg",
                logoUrl: process.env.BASE_URL + "img/logo.png",
                logined: false,
                loginAuth: [
                ],
                menuIfShow:false,
            }
        },
        created() {
            let userToken = localStorage.getItem("current_user_token");
            if (userToken !== undefined && userToken !== null) {
                this.$axios.post(this.$url+'/get_authority',{userToken:userToken,target:'index'})
        .then(response=>{
            if(response.data=="authority_pass"){
                this.logined = true;
            }else{
                localStorage.clear();
                window.location.href='/system_login';
            }
        })
            }
        },
        mounted() {
        },
        props: {
        },
        methods: {
            LogOut: function () {
                localStorage.clear();
                this.logined = false;
                location.href = "/system_login";
            },
            goSearch:function(){
                location.href = "/search/search_result";
            },
            menuToggle:function(val){
                this.menuIfShow = val;
            }

        }

    }
</script>

<style>
.layout-workframe{
    position: relative;
}

.menu-bar-workframe{
    position: absolute;
    left:0;
    top:37px;
    z-index: 999;
}

table{
  border-collapse:collapse!important;
}

</style>